<template>
  <v-container>
    <v-row xs11 justify="space-between" align="center">
      <div
        v-if="showEventEditControls"
        class="d-flex flex-row ml-2 align-baseline"
      >
        <v-autocomplete
          v-model="selectedEvents"
          label="Events"
          hint="Select Events to which this category should be added"
          :items="eventList"
          clearable
          multiple
          class="white--text mr-2"
          item-color="#78909c"
          clear-icon="mdi-close-circle"
          :search-input.sync="search"
        >
          <template v-slot:selection="{ attr, on, item, index, selected }">
            <v-chip
              v-bind="attr"
              :input-value="selected"
              color="#78909c"
              class="white--text"
              small
              v-on="on"
              close
              @click:close="removeEventItem(index)"
            >
              <span v-text="item"></span>
            </v-chip>
          </template>
        </v-autocomplete>

        <v-btn class="mx-2" @click="setNewEventList" color="primary" x-small>
          Set
        </v-btn>
        <v-btn
          @click="$emit('update:showEventEditControls', false)"
          color="secondary"
          outlined
          text
          x-small
        >
          Cancel
        </v-btn>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "EditEvents",
  components: {},
  props: {
    node: Object,
    selectedRecord: Object,
    showEventEditControls: Boolean,
    events: Object
  },
  data() {
    return {
      selectedEvents: [],
      search: ""
    };
  },
  mounted() {
    if (this.node.meta.events) {
      this.selectedEvents = this.node.meta.events.concat();
    }
  },
  computed: {
    ...mapState({
      currentlyFullRecordId: state =>
        state.records.currentlySelectedTab.recordId
    }),
    eventList() {
      return Object.keys(this.events);
    }
  },
  methods: {
    setNewEventList() {
      // Iterate through the existing events list and remove ones not in the new list
      if (this.node.meta.events) {
        this.node.meta.events.map(event => {
          if (this.selectedEvents.indexOf(event) === -1) {
            this.$store.commit("REMOVE_NODE_FROM_EVENTS_GROUP", {
              node: this.node,
              event,
              recordId: this.currentlyFullRecordId
            });
          }
        });
        // Iterate through the new events list and add ones not in the old list
        this.selectedEvents.map(event => {
          if (
            !this.node.meta.events ||
            this.node.meta.events.indexOf(event) === -1
          ) {
            this.$store.commit("ADD_NODE_TO_EVENTS_GROUP", {
              node: this.node,
              event,
              recordId: this.currentlyFullRecordId
            });
          }
        });
      }
      this.node.meta.events = this.selectedEvents.concat();
      this.updateNode();

      this.$emit("update:showEventEditControls", false);
    },
    removeEventItem(index) {
      this.selectedEvents.splice(index, 1);
      this.search = "";
    },
    async updateNode() {
      const payload = {
        obj: this.node,
        root_id: this.currentlyFullRecordId
      };
      const response = await this.$store.dispatch(
        "updateRecNode/updateRecordNode",
        payload
      );
    }
  },
  watch: {}
};
</script>

<style lang="scss"></style>
